import { TeamsAPI } from 'api/teams';
import { teamsCollection } from './teams-collection';
export const fetchAllTeams = async ()=>{
    const teams = await TeamsAPI.getAllTeamsInAccount();
    teamsCollection.push(teams, {
        source: 'fetch'
    });
    return teams;
};
export const fetchProjectTeams = async (projectId)=>{
    const teams = await TeamsAPI.getProjectPlaceholders(projectId);
    teamsCollection.push(teams, {
        source: 'fetch'
    });
    return teams;
};
